{"title":"So ein schöner Name! {{pet_name}} ist ein ...","cta":"Weiter","male":"Männchen","female":"Weibchen"}